<div class="nacho-wrap d-flex align-items-end">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-auto text-center">
                <a href="/nacho-gallery" class="btn neon-pink-bg white">Look alive!</a>
            </div>
        </div>
    </div>
</div>
